import React from 'react';
import styled from 'styled-components';
import { Tooltip } from 'primereact/tooltip';
import IntlStore from "stories/IntlStore";
import {FormattedMessage} from "react-intl";

interface StatusProps {
  status: string;
  isMinimalistic?: boolean;
}

const colorMap: Record<string, string> = {
  MODERATE: '#FEE48A',
  ERROR: '#FF8F8F',
  DRAFT: '#D7D7D7',
  EDIT: '#7EFFFF',
  RELEASED: '#87FF9B',
};

const translationMap: Record<string, string> = {
  MODERATE: IntlStore.intl.formatMessage({
    id: "Releases.Statusbar.Moderation",
    defaultMessage: "Moderation"
  }),
  ERROR: IntlStore.intl.formatMessage({
    id: "Releases.Statusbar.Error",
    defaultMessage: "Error"
  }),
  DRAFT: IntlStore.intl.formatMessage({
    id: "Releases.Statusbar.Draft",
    defaultMessage: "Draft"
  }),
  EDIT: IntlStore.intl.formatMessage({
    id: "Releases.Statusbar.Editing",
    defaultMessage: "Editing"
  }),
  RELEASED: IntlStore.intl.formatMessage({
    id: "Releases.Statusbar.Released",
    defaultMessage: "Released"
  }),
};

export const Status: React.FC<StatusProps> = props => {
  const { status, isMinimalistic = false } = props;
  return (
    <>
      <Tooltip target=".status-tooltip" position="top">{translationMap[status] || '-'}</Tooltip>
      <Container status={status} className={isMinimalistic ? "status-tooltip" : ""} isMinimalistic={isMinimalistic}>
        {isMinimalistic
          ? '/'
          : <span>
              <FormattedMessage
                id="Releases.Status.Status"
                defaultMessage="Status: "
              />
              {' '}
              {translationMap[status] || '-'}
          </span>
        }
      </Container>
    </>
  );
};

const Container = styled.div<{ status: string; isMinimalistic: boolean }>`
  display: flex;
  align-items: center;
  gap: 4px;
  height: 20px;
  padding: 4px 6px;
  border-radius: 4px;
  background: ${props => colorMap[props.status] || '#7EFFFF'};
  font-weight: 500;
  font-size: 12px;
  line-height: 12px;

  ${props => props.isMinimalistic && `
    border-radius: 50%;
    width: 13px;
    height: 13px;
    font-size: 6px;
  `};
`;
